module.exports = __webpack_public_path__ + "static/media/e2.9d2fd9b3.jpg";